import React from 'react';

/**
 * SafeChurch logo — recreated as SVG so it stays crisp at any size and doesn't
 * depend on any external image host. Matches the UPCI SafeChurch branding: a
 * clean black cross inside a circle, with the word "SAFECHURCH" across the
 * horizontal bar of the cross.
 *
 * Prop `variant`:
 *   - "dark"  → black cross on white circle, dark ring (default, use on light bg)
 *   - "light" → white cross on transparent circle (use on dark hero backgrounds)
 */
const SafeChurchLogo = ({ size = 96, variant = 'dark', className = '' }) => {
  const isDark = variant === 'dark';
  const ring = isDark ? '#0f766e' : '#ffffff';         // teal ring / white ring
  const circleFill = isDark ? '#ffffff' : 'transparent';
  const cross = isDark ? '#0f172a' : '#ffffff';        // near-black / white
  const text = isDark ? '#ffffff' : '#0f172a';         // text sits on the bar

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role="img"
      aria-label="SafeChurch"
      className={className}
    >
      {/* Outer ring */}
      <circle cx="50" cy="50" r="47" fill={ring} />
      {/* Inner circle */}
      <circle cx="50" cy="50" r="43" fill={circleFill} />
      {/* Cross vertical */}
      <rect x="42" y="14" width="16" height="72" rx="1" fill={cross} />
      {/* Cross horizontal bar */}
      <rect x="14" y="42" width="72" height="16" rx="1" fill={cross} />
      {/* Text */}
      <text
        x="50"
        y="53.5"
        textAnchor="middle"
        fontFamily="Helvetica, Arial, sans-serif"
        fontWeight="800"
        fontSize="10"
        letterSpacing="0.5"
        fill={text}
      >
        SAFECHURCH
      </text>
    </svg>
  );
};

export default SafeChurchLogo;
